module.exports = __webpack_public_path__ + "static/img/smartControlCore3.038704d6.png";